<div class="min-h-screen bg-surface">
  <div class="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-8">
    <a
      routerLink="/writing"
      class="mb-6 inline-flex items-center gap-2 text-sm font-medium text-slate-600 transition-colors hover:text-slate-900"
    >
      <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
      </svg>
      返回写作
    </a>

    <h1 class="font-display text-2xl font-bold text-slate-900">选择年月</h1>
    <p class="mt-1 text-sm text-slate-500">选择要查看或练习的题目组合</p>

    <div class="mt-8 space-y-6">
      @for (group of yearGroups(); track group.year) {
        <div>
          <h2 class="mb-3 text-sm font-semibold uppercase tracking-wider text-slate-500">
            {{ group.year }}年
          </h2>
          <div class="grid grid-cols-2 gap-2 sm:grid-cols-4">
            @for (period of group.months; track period.combinationId) {
              <button
                type="button"
                class="flex items-center justify-between gap-2 rounded-xl border border-slate-200 bg-white px-4 py-3 text-left shadow-sm transition-all hover:border-slate-300 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                (click)="selectPeriod(period)"
              >
                <span class="truncate font-medium text-slate-900">{{ period.label }}</span>
                <svg class="h-4 w-4 shrink-0 text-slate-400" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                </svg>
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
